module.exports = __webpack_public_path__ + "static/media/clock.de3914f3.svg";